export default "__VITE_ASSET__7d0372d3__"